import { FC } from 'react';
import { useDetailsBooking } from 'lib/hooks';
import { AlertProps, ExternalLink } from '@qga/roo-ui/components';
import { ImportantInfoAlert } from '../Alerts/ImportantInfoAlert';
import { manageQantasInPathFlightBookingLinkSelected } from 'lib/gaTracking/crossPageEvents';

export const InPathFlightBookingAlert: FC<Partial<AlertProps>> = ({ p = 2, mb = 5, ...props }) => {
  const {
    booking: { channel, reference },
  } = useDetailsBooking();

  if (channel !== 'qantas_in_path') {
    return null;
  }

  return (
    <ImportantInfoAlert p={p} mb={mb} {...props}>
      <ImportantInfoAlert.Heading>
        Any changes, amendments or cancellations to your hotel booking will not affect your Qantas flight booking.
      </ImportantInfoAlert.Heading>
      <ImportantInfoAlert.Body>
        To make changes to your flights (#{reference}) this will need to be done separately via{' '}
        <ExternalLink
          href="https://www.qantas.com/au/en/manage-booking.html"
          target="_blank"
          underline
          onClick={manageQantasInPathFlightBookingLinkSelected}
        >
          manage your flight booking
        </ExternalLink>
        .
      </ImportantInfoAlert.Body>
    </ImportantInfoAlert>
  );
};
